import React, { useState } from 'react'
 
 
import BroadCastMessageList from './BroadCastMessageList';
import BroadCastMessageForm from './BroadCastMessageForm';

const BroadCastMessage= () => {
    const [fromIsShown, setFromIsShown] = useState(false);
    const [upData, setUpData] = useState(false);

  return (
    <>
      {fromIsShown ? (
          <BroadCastMessageForm addForm={setFromIsShown} update={upData} />
        ) : (
          <BroadCastMessageList addForm={setFromIsShown} update={setUpData} />
        )}  
    </>
  )
}

export default BroadCastMessage